import AxiosService from '@/api/ApiBase';
import { ChargeCodes } from '@/composables/charges/useChargeCodes';
import { ChargeInvoiceCreatePayload } from '@/types/charge/invoices/charge-invoice.types';
import { QueryResponsePayment } from '@/types/charge/invoices/charge-invoice-response.types';

const CHARGE_INVOICE_BASE_URL = 'warehouse/charges/invoice';

class ChargeInvoiceService {
  generateInvoice(payload: ChargeInvoiceCreatePayload) {
    return AxiosService.post<string>(`${CHARGE_INVOICE_BASE_URL}/generate`, payload);
  }

  deleteInvoice(invoiceId: string, qbClient: string) {
    return AxiosService.delete(`${CHARGE_INVOICE_BASE_URL}/delete`, {
      params: {
        invoiceId,
        qbClient,
      },
    });
  }

  voidInvoice(invoiceId: string) {
    return AxiosService.delete(`${CHARGE_INVOICE_BASE_URL}/delete`, {
      params: {
        invoiceId,
      },
    });
  }

  getAll(manifestId: string) {
    return AxiosService.get<ChargeCodes[]>(`${CHARGE_INVOICE_BASE_URL}/all`, {
      params: {
        manifestId,
      },
    });
  }
  getPaymentDetails(invoiceId: string) {
    return AxiosService.get<QueryResponsePayment>(`${CHARGE_INVOICE_BASE_URL}/payment`, {
      params: {
        invoiceId,
      },
    });
  }
  hasActiveCharges(manifestId: string) {
    return AxiosService.get<{ status: boolean }>(`${CHARGE_INVOICE_BASE_URL}/status`, {
      params: {
        manifestId,
      },
    });
  }
}

export default new ChargeInvoiceService();
